import { Alert } from 'antd';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)`
  padding: 10px;
  margin-bottom: 20px;
`;

export const ErrorMessage = styled.div`
  color: #a10d0d;
  line-height: 30px;
  display: list-item;
  list-style-type: circle;
  list-style-position: inside;
`;
